import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=f4c66e7c&scoped=true"
import script from "./InvoicesTable.vue?vue&type=script&lang=js"
export * from "./InvoicesTable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=f4c66e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c66e7c",
  null
  
)

/* custom blocks */
import block0 from "./InvoicesTable.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports